/**
 * 입력칸 위 자료 줄 — 고른 분기의 렌더 함수 하나만 부른다. 순수 UI 다.
 * 무엇을 고를지는 resolveAiGenerateDockSourceRow 가, 각 분기에 무엇을 그릴지는 호출부가 정한다.
 */
import { type ReactNode } from 'react';
import { type AiGenerateDockLinkSourceType } from '../consts/aiGenerateDock.const';
import { type AiGenerateDockAttachment } from '../types/aiGenerateDock.types';
import { type AiGenerateDockSourceRowState } from '../utils/aiGenerateDockSourceRow';
export const AiGenerateDockSourceRow = ({
  row,
  attachment,
  file,
  link
}: {
  row: AiGenerateDockSourceRowState;
  attachment: (attachment: AiGenerateDockAttachment) => ReactNode;
  file: () => ReactNode;
  link: (sourceType: AiGenerateDockLinkSourceType) => ReactNode;
}) => {
  switch (row.kind) {
    case 'attachment':
      return <div className="flex w-full">{attachment(row.attachment)}</div>;
    case 'file':
      return file();
    case 'link':
      return link(row.sourceType);
    case 'none':
      return null;
  }
};